module.exports = __webpack_public_path__ + "static/media/icon-promo.ab73e1ac.svg";